<div class="barra_estado_flotante">{{ text }}</div>
